import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import {
  NgbModule,
  NgbDateAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import {
  FontAwesomeModule,
  FaIconLibrary,
} from "@fortawesome/angular-fontawesome";
import { DataTablesModule } from "angular-datatables";
import { HighchartsChartModule } from "highcharts-angular";
import "@angular/common/locales/global/es";

import { AppComponent } from "./app.component";
import { routes } from "./app.routes";
import { CentralService } from "./servicios/central.service";
import { AutenticarService } from "./servicios/autenticar.service";
import { SegurGuard } from "./servicios/segur.guard";
import { Interceptor } from "./servicios/interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { Estfecha } from "./servicios/esfecha";
import { Esfmtfec } from "./servicios/esfmtfec";

import { CabeceraComponent } from "./cabecera/cabecera.component";
import { PieComponent } from "./pie/pie.component";
import { PortadaComponent } from "./portada/portada.component";
import { acercadeComponent } from "./Acerca de/acercade.component";
import { LoginComponent } from "./login/login.component";
import { AvisosComponent } from "./avisos/avisos.component";
import { FichacapComponent } from "./fichacap/fichacap.component";
import { MdfclaveComponent } from "./mdfclave/mdfclave.component";
import { FichacaplisComponent } from "./fichacap/fichacaplis.component";
import { FichacapimpComponent } from "./fichacap/fichacapimp.component";
import { PiensosComponent } from "./piensos/piensos.component";
import { PiensosgrfComponent } from "./piensos/piensosgrf.component";
import { PiensosimpComponent } from "./piensos/piensosimp.component";
import { piensoslisComponent } from "./piensos/piensoslis.component";
import { EntregasComponent } from "./entregas/entregas.component";
import { EntregalisComponent } from "./entregas/entregalis.component";
import { EntregaimpComponent } from "./entregas/entregaimp.component";
import { EntregagrfComponent } from "./entregas/entregagrf.component";
import { AnticipoComponent } from "./anticipo/anticipo.component";
import { AnticipolisComponent } from "./anticipo/anticipolis.component";
import { AnticipoimpComponent } from "./anticipo/anticipoimp.component";
import { LiquidaComponent } from "./liquida/liquida.component";
import { LiquidaimpComponent } from "./liquida/liquidaimp.component";
import { LiquidalisComponent } from "./liquida/liquidalis.component";
import { FacturaComponent } from "./factura/factura.component";
import { FactulisComponent } from "./factura/factulis.component";
import { FactuimpComponent } from "./factura/factuimp.component";
import { AdminPanelComponent } from "./admin/adminPanel.component";
import { GestionPiensos } from "./gestionpiensos/gestionpiensos.component";
import { EntregaOpcionComponent } from "./entregas/entregaOpcion.component";
import { PiensosOpcionComponent } from "./piensos/piensosOpcion.component";
import { AdminLisPiensosComponent } from "./admin/adminLisPiensos.component";
import { AdminPiensosForm } from "./admin/adminPiensosForm.component";
import { AdminLisCorderosComponent } from "./admin/adminLisCorderos.component";
import { AdminCorderosFormComponent } from "./admin/adminCorderosForm.component";

import {
  faHome,
  faSignInAlt,
  faSignOutAlt,
  faKey,
  faEuroSign,
  faPrint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUserTie,
  faCheckCircle,
  faUndo,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { LayoutComponent } from "./layout.component";
import { ClienteFilterPipe } from "./admin/clienteFilterPipe";

@NgModule({
  declarations: [
    AppComponent,
    CabeceraComponent,
    PieComponent,
    PortadaComponent,
    LoginComponent,
    AvisosComponent,
    FichacapComponent,
    MdfclaveComponent,
    FichacaplisComponent,
    FichacapimpComponent,
    PiensosComponent,
    PiensosgrfComponent,
    PiensosimpComponent,
    piensoslisComponent,
    EntregasComponent,
    EntregalisComponent,
    EntregaimpComponent,
    EntregagrfComponent,
    AnticipoComponent,
    AnticipolisComponent,
    AnticipoimpComponent,
    LiquidaComponent,
    LiquidaimpComponent,
    LiquidalisComponent,
    FacturaComponent,
    FactulisComponent,
    FactuimpComponent,
    AdminPanelComponent,
    GestionPiensos,
    EntregaOpcionComponent,
    PiensosOpcionComponent,
    AdminLisPiensosComponent,
    AdminPiensosForm,
    AdminLisCorderosComponent,
    AdminCorderosFormComponent,
    LayoutComponent,
    ClienteFilterPipe,
  ],
  imports: [
    BrowserModule,
    routes,
    HttpClientModule,
    FontAwesomeModule,
    NgbModule,
    FormsModule,
    DataTablesModule,
    HighchartsChartModule,
  ],
  providers: [
    CentralService,
    AutenticarService,
    SegurGuard,
    { provide: LOCALE_ID, useValue: "es" },
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    { provide: NgbDateAdapter, useClass: Estfecha },
    { provide: NgbDateParserFormatter, useClass: Esfmtfec },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    // Add icons to the library for convenient access in other components
    library.addIcons(
      faHome,
      faSignInAlt,
      faSignOutAlt,
      faKey,
      faEuroSign,
      faPrint,
      faFileAlt,
      faTractor,
      faMoneyBill,
      faFileInvoice,
      faUserTie,
      faCheckCircle,
      faUndo,
      faCalendarAlt
    );
  }
}
